import { camelCaseToKebabCase } from '@augment-vir/common';
export function toHtmlSafeWithTagName(tagName, forHtmlSafe) {
    return `${tagName}-${camelCaseToKebabCase(forHtmlSafe)}`;
}
